// @ts-nocheck
/* eslint-disable */
import Content from '~/content';
import Profile from "~/profile/main";
import { _ } from "~/i18n";

Mapy.ProfileContent = class extends Content {
	constructor(store) {
		super();
		this._contentName = "profile";
		this._profile = new Profile(store);
		this._dom = {
			container: this._profile.container
		}
	}

	activate() {
		super.activate();
		Mapy.getComponent("stateswitch").setState(this);
		Mapy.SEO.set(
			_("profile.seo"),
		);
	}

	deactivate() {
		super.deactivate();
	}

	show() {
		Mapy.CML.state = {
			route: {
				showGeometries: true
			}
		}

		return super.show();
	}

	hide() {
		Mapy.CML.state = {
			route: {
				showGeometries: false
			}
		}

		return super.hide();
	}

	rebuild() {
		this._profile.rebuild();
	}

	getAvatar() {
		return this._profile.avatar;
	}

	getBigAvatar() {
		return this._profile.bigAvatar;
	}

	getButton() {
		return this._profile.button;
	}

	get container() {
		return this._dom.container;
	}

	checkDebug(show) {
		this._profile.checkDebug(show);
	}
};
